import { getByTabKey } from 'app/client/modules/Search/contracts';
import { searchAction } from '@exonet/jsonapi-fetcher/lib/search';

const mapStateToProps = ({ app }) => ({
  customerId: app.customer.id,
});

const mapDispatchToProps = (dispatch) => ({
  search: (value, customerId, tab, indexKeys) =>
    dispatch(searchAction(getByTabKey(tab, value, customerId, indexKeys)).get()),
});

export default [mapStateToProps, mapDispatchToProps];
